export const ACTION_GET_CURRENT_STEP = 'ACTION_GET_CURRENT_STEP'
export const ACTION_SET_CURRENT_STEP = 'ACTION_SET_CURRENT_STEP'
export const ACTION_GET_EXAM_QUESTIONS = 'ACTION_GET_EXAM_QUESTIONS'
export const ACTION_GET_EXAM_QUESTIONS_COUNT = 'ACTION_GET_EXAM_QUESTIONS_COUNT'
export const ACTION_SAVE_ANSWER = 'ACTION_SAVE_ANSWER'
